import { atom } from 'recoil'

export const errorAtom = atom({
    key: 'applicationError',
    default: undefined
})
